import { Entity } from './types';
import { updateRecord } from './updateRecord';

type Condition<T> = (item: T) => boolean;
type UpdateRecordWhere = <T extends Entity>(
  record: Record<string, T>,
  condition: Condition<T>,
  newValues: Partial<T>
) => Record<string, T>;
export const updateRecordWhere: UpdateRecordWhere = (record, condition, newValues) =>
  Object.values(record).reduce((updated, item) => {
    if (condition(item)) {
      return updateRecord(updated, item.id, newValues);
    }

    return updated;
  }, record);
